import {RestfulEndpoint, RestfulFetchOptions, RestfulIOOptions} from "type-r/endpoints/restful";
import {IOPromise, IOEvents, createIOPromise} from "type-r";
import globalStore from "./globalStore";
import {getCookie} from 'tiny-cookie';

class AuthEndpoint extends RestfulEndpoint {
    public static defaultFetchOptions: RestfulFetchOptions = {
        cache: "no-cache",
        mode: "cors",
        redirect: "error",
    };

    protected request(method: string, url: string, {options}: RestfulIOOptions, body?: any): IOPromise<any> {
        options = options || {};
        options.headers = options.headers || {};
        if (globalStore.activeToken) {
            (options.headers as any).Authorization = 'Token ' + globalStore.activeToken;
        }
        if (url.substr(-5, 5) !== '.json') {
            if (url.substr(-1, 1) === '/') {
                url = url.substr(0, url.length - 1);
            }
            url += '.json';
        }
        if(method.toLowerCase() !== 'get') {
            const csrftoken = getCookie('csrftoken');
            if (csrftoken) {
                (options.headers as any)["X-CSRFtoken"] = csrftoken;
            }
        }
        return fetch(url, this.buildRequestOptions(method, options, body))
            .then(function (response: Response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return response.json()
                        .then(error => {
                            if(response.status === 400 && error){
                                console.log(error);
                            }
                            if(error.non_field_errors){
                                return error.non_field_errors.join('\n')
                            }
                            return {detail:error};
                        })
                        .catch(() => {
                            // if can't json decode - throw simple error
                            throw new Error(response.statusText);
                        })
                        .then((error: any)=>{
                            console.warn("In error select field with message text:", error);
                            if(error.detail){
                                error.message = "Ошибка в сохраняемых данных";
                                error.toString = ()=>error.message;
                                throw error;
                            }
                            throw new Error(String(error));
                        })
                }
            });
    }
}

export function appIO(url: string, options: any = null) {
    return new AuthEndpoint(url, options);
}



// WEBPACK FOOTER //
// ./src/models/AuthEndpoint.ts